
  var _styles = {
  "city_horizontal": {
    "position": "relative"
  },
  "city_horizontal_scroll": {
    "paddingTop": "0.16rem",
    "paddingRight": 0,
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "city_horizontal_content": {
    "display": "flex",
    "flexDirection": "row",
    "height": "auto",
    "paddingTop": "0.16rem",
    "paddingRight": 0,
    "paddingBottom": "0.08rem",
    "paddingLeft": 0
  },
  "city_horizontal_card": {
    "paddingTop": "0.21333rem",
    "paddingRight": "0.36rem",
    "paddingBottom": "0.21333rem",
    "paddingLeft": "0.36rem",
    "background": "#fff",
    "marginRight": "0.16rem",
    "borderRadius": "0.16rem",
    "display": "flex",
    "alignItems": "center"
  },
  "city_horizontal_card_text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "letterSpacing": 0,
    "fontWeight": "400"
  },
  "city_horizontal_position": {
    "position": "absolute",
    "right": 0,
    "top": "0.16rem",
    "width": "1.33333rem",
    "height": "0.96rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-end",
    "marginBottom": 0
  },
  "city_horizontal_position_left": {
    "width": "0.53333rem",
    "height": "100%"
  },
  "city_horizontal_position_right": {
    "width": "0.8rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "0.96rem",
    "marginBottom": "0.08rem"
  },
  "base1": {
    "width": "0.53333rem",
    "height": "0.53333rem"
  },
  "city_horizontal_card-1": {
    "paddingTop": "0.21333rem",
    "paddingRight": "0.36rem",
    "paddingBottom": "0.21333rem",
    "paddingLeft": "0.36rem",
    "background": "#fff",
    "marginRight": "0.16rem",
    "borderRadius": "0.16rem",
    "display": "flex",
    "alignItems": "center",
    "marginBottom": "0.13333rem"
  },
  "city-drop-down-modal": {
    "position": "absolute",
    "width": "9.36rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "overflow": "hidden",
    "backgroundColor": "rgb(255,255,255)"
  }
};



  module.exports = _styles;
  